// extracted by mini-css-extract-plugin
export var header = "layout-module--header--1RSvl";
export var content = "layout-module--content--155cd";
export var nav = "layout-module--nav--2rcXG";
export var logo = "layout-module--logo--2cDAN";